/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Modal')
    .directive('accHandleEnterKeypress', function(){
        return {
            scope: true,
            link: function ($scope, $element, $attrs) {
                if ($scope.modal.onEnter) {
                    $element.parents('.modal').keydown(function($event){
                        if ($event.which == 13) $scope[$scope.modal.onEnter]();
                    });
                }
            }
        }
    });
 
 
